import { render, staticRenderFns } from "./investorAnalyst.vue?vue&type=template&id=50edb292"
import script from "./investorAnalyst.vue?vue&type=script&lang=js"
export * from "./investorAnalyst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports